import { checkResult } from "@/common";
import { BaseService } from "@/service";
export function Industrial(value) {
    switch (value) {
        case 1:
            return ('大专院校科研院所');
            break;
        case 2:
            return ('社会专业研发机构');
            break;
        case 3:
            return ('大型头部企业集团');
            break;
        case 4:
            return ('创新创业中小企业');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Business(value) {
    switch (value) {
        case 1:
            return ('研究开发');
            break;
        case 2:
            return ('生产制造');
            break;
        case 3:
            return ('市场营销');
            break;
        case 4:
            return ('科技服务');
            break;
        default:
            return ('未选择');
            break;
    }
}



export function Height(value) {
    switch (value) {
        case 1:
            return ('国际领先');
            break;
        case 2:
            return ('国际先进');
            break;
        case 3:
            return ('国内先进');
            break;
        case 4:
            return ('国内空白');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Attribute(value) {
    switch (value) {
        case 1:
            return ('重大自主原创技术');
            break;
        case 2:
            return ('产业关键核心技术');
            break;
        case 3:
            return ('国际前沿引领技术');
            break;
        case 4:
            return ('新兴产业支撑技术');
            break;
        default:
            return ('未选择');
            break;
    }
}


export function Achievement(value) {
    switch (value) {
        case 1:
            return ('国际发明专利');
            break;
        case 2:
            return ('国家发明专利');
            break;
        case 3:
            return ('国家科技奖项');
            break;
        case 4:
            return ('行业领军产品');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Shape(value) {
    switch (value) {
        case 1:
            return ('软件硬件材料');
            break;
        case 2:
            return ('小型仪器装置');
            break;
        case 3:
            return ('大型机械装备');
            break;
        case 4:
            return ('系统应用平台');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Scale(value) {
    switch (value) {
        case 1:
            return ('年创收十亿以上');
            break;
        case 2:
            return ('年创收一亿以上');
            break;
        case 3:
            return ('年创收千万以上');
            break;
        case 4:
            return ('年创收千万以下');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Expect(value) {
    switch (value) {
        case 1:
            return ('未来市场千亿级');
            break;
        case 2:
            return ('未来市场百亿级');
            break;
        case 3:
            return ('未来市场十亿级');
            break;
        case 4:
            return ('未来市场亿元级');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Difficulty(value) {
    switch (value) {
        case 1:
            return ('资源复杂难度很大');
        case 2:
            return ('资源较多难度一般');
        case 3:
            return ('资源条件难度不大');
        default:
            return ('未选择');
            break;
    }
}

export function Degree(value) {
    switch (value) {
        case 1:
            return ('所需资源全部到位');
            break;
        case 2:
            return ('有缺口有计划安排');
            break;
        case 3:
            return ('缺口较大需要帮助');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Strength(value) {
    switch (value) {
        case 1:
            return ('投资很大已经到位');
            break;
        case 2:
            return ('有缺口有计划安排');
            break;
        case 3:
            return ('缺口较大需要帮助');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Trl1_9(value) {
    switch (value) {
        case 1:
            return ('技术方案设计');
            break;
        case 2:
            return ('建成实验装置');
            break;
        case 3:
            return ('完成概念验证');
            break;
        case 4:
            return ('完成产品设计');
            break;
        case 5:
            return ('完成产品中试');
            break;
        case 6:
            return ('成功应用案例');
            break;
        case 7:
            return ('实现生产制造');
            break;
        case 8:
            return ('进入市场营销');
            break;
        case 9:
            return ('建成产业体系');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Leader_education(value) {
    switch (value) {
        case 1:
            return ('博士研究生');
            break;
        case 2:
            return ('硕士研究生');
            break;
        case 3:
            return ('大学本科');
            break;
        case 4:
            return ('大专');
            break;
        case 5:
            return ('中专');
            break;
        case 6:
            return ('高中');
            break;
        case 7:
            return ('其它');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Leader_title(value) {
    switch (value) {
        case 1:
            return ('高级职称');
            break;
        case 2:
            return ('中级职称');
            break;
        case 3:
            return ('初级职称');
            break;
        case 4:
            return ('无');
            break;
        default:
            return ('未选择');
            break;
    }
}
export function Team_person(value) {
    switch (value) {
        case 1:
            return ('10人以上（含）');
            break;
        case 2:
            return ('10人以下');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Team_intermediate(value) {
    switch (value) {
        case 1:
            return ('50%以上（含）');
            break;
        case 2:
            return ('50%以下');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Team_experience(value) {
    switch (value) {
        case 1:
            return ('2年以上（含）');
            break;
        case 2:
            return ('2年以下');
            break;
        default:
            return ('未选择');
            break;
    }
}

export function Recommend_state(value) {
    switch (value) {
        case 0:
            return ('待推荐');
            break;
        case 1:
            return ('已编写推荐意见');
            break;
        case 2:
            return ('已驳回未推荐');
            break;
        default:
            return ('无推荐状态');
            break;
    }
}

export function Revenue(value) {
    switch (value) {
        case 1:
            return ('十亿以上（含）');
        case 2:
            return ('亿元以上（含）');
        case 3:
            return ('千万以上（含）');
        case 4:
            return ('百万以上（含）');
    }
}

export function CategoryName(value) {
    switch (value) {
        case 1:
            return ('科研院所');
        case 2:
            return ('大专院校');
        case 3:
            return ('专业学会');
        case 4:
            return ('行业协会');
        case 5:
            return ('央企/国企');
        case 6:
            return ('非公企业');
        case 7:
            return ('产业园区');
        case 8:
            return ('其它');
    }
}

export function DutiesName(value) {
    switch (value) {
        case 1:
            return ('主任委员');
        case 2:
            return ('副主任委员');
        case 3:
            return ('特聘专家');
        case 4:
            return ('委员');
    }
}

export function Report_TypeName(value) {
    switch (value) {
        case 1:
            return ('领航项目');
        case 2:
            return ('启航项目');
        case 3:
            return ('备航项目');
        case 0:
            return ('请选择');
    }
}


export function RecommendStateName(value) {
    switch (value) {
        case 0:
            return ('待推荐');
        case 1:
            return ('已推荐');
        case 2:
            return ('未推荐');
        default:
            return ('其它');
    }
}

export function NewsIdentifyName(value) {
    switch (value) {
        case "1":
            return ('动态新闻');
        case "2":
            return ('通知公告');
        case "3":
            return ('文件下载');
        default:
            return ('其它');
    }
}

export function PersonRecName(value) {
    switch (value) {

        case "02380ea052d311efbb762b032d656842":
            return ("黄中-清华大学工业锅炉及民用煤清洁燃烧国家工程研究中心");
        case "e201192052d111efbb762b032d656842":
            return ("王淼辉-京津冀国家技术创新中心");
        case "119e46d052d211ef88144f91e58a0a62":
            return ("汪瑞军-中国农业机械化科学研究院集团有限公司新材料所");
        case "d2c1069052d211efbb762b032d656842":
            return ("汪少朋-中国纺织科学研究院");
        case "f0c1627052d211efbb762b032d656842":
            return ("金旭-中石油勘探开发研究院智能控制与装备研究所");
        case "02380ea052d311efbb762b032d656842":
            return ("黄中-清华大学工业锅炉及民用煤清洁燃烧国家工程研究中心");
        case "2824281052d311ef88144f91e58a0a62":
            return ("严大洲-中国五矿集团有限公司");
        case "524d479052d611efbb762b032d656842":
            return ("黄祖广-通用技术机床研究院");
        case "63c468f052d611efbb762b032d656842":
            return ("李海生-中国环境科学研究院");
        case "752bf9f052d611efbb762b032d656842":
            return ("路新-北京科技大学新材料技术研究院");
        case "fb0c970052d611ef88144f91e58a0a62":
            return ("林民-中国石化石油化工科学研究院");
        case "09ed07f052d711ef88144f91e58a0a62":
            return ("束国刚-中国联合重型燃气轮机技术有限公司");
        case "1ae7312052d711ef88144f91e58a0a62":
            return ("李红卫-有研科技集团有限公司");
        case "2e547d3052d711ef88144f91e58a0a62":
            return ("张福明-首钢总公司");
        case "3ee7591052d711ef88144f91e58a0a62":
            return ("何金江-有研新材料股份有限公司");
        case "4f39d09052d711ef88144f91e58a0a62":
            return ("田天-北京瑞莱智慧科技有限公司");
        case "b85d2af0539911efbc508db36a78dbfe":
            return ("黄小卫-有研科技集团有限公司");
        default:
            return ('');
    }
}

export function ProjectScopeName(value) {
    switch (value) {
        case "05ceceb0878d11eb800b29fd3217a134":
            return ("现代服务");
        case "0d341e30878d11ebbde9e797d995acb3":
            return ("基建工程");
        case "14669de0878d11eb800b29fd3217a134":
            return ("航空航天");
        case "237794b0878d11ebbde9e797d995acb3":
            return ("海洋工程");
        case "2e565380878d11eb800b29fd3217a134":
            return ("人工智能");
        case "457c03e0d41111eb825aa78209a08e3f":
            return ("生物工程");
        case "531db340d41111eb825aa78209a08e3f":
            return ("能源化工");
        case "585cee70d41111eb825aa78209a08e3f":
            return ("食品产业");
        case "622449d0d41111eb825aa78209a08e3f":
            return ("材料产业");
        case "69c765a0d41111eb825aa78209a08e3f":
            return ("仪器仪表");
        case "d6d5f750878c11eb800b29fd3217a134":
            return ("先进制造");
        case "dec7a850878c11ebbde9e797d995acb3":
            return ("健康医疗");
        case "e8387f40878c11eb800b29fd3217a134":
            return ("电子信息");
        case "f210a380878c11ebbde9e797d995acb3":
            return ("交通电力");
        case "f82900a0878c11eb800b29fd3217a134":
            return ("现代农业");
        case "ff2db990878c11ebbde9e797d995acb3":
            return ("节能环保");
        default:
            return ('');
    }
}